import type { Notification } from '../types.ts';

interface NotificationToastProps {
  notif: Notification | null;
}

export default function NotificationToast(p: NotificationToastProps) {
  if (!p.notif) return null;
  const isLevelUp = p.notif.type === 'levelup';
  const isStreak = p.notif.type === 'streak';
  const isSuccess = p.notif.type === 'success' || isLevelUp || isStreak;
  const bg = isLevelUp
    ? 'bg-qpurple'
    : isStreak
      ? 'bg-gradient-to-r from-qcoral to-qpurple'
      : isSuccess
        ? 'bg-qteal'
        : 'bg-qcoral';
  return (
    <div
      className={
        'fixed top-[calc(16px+env(safe-area-inset-top))] left-1/2 -translate-x-1/2 px-6 py-3 rounded-btn font-bold text-sm z-[1000] text-white shadow-lg animate-slide-up ' +
        bg
      }
    >
      {isLevelUp ? '🎉 ' : isStreak ? '🔥 ' : ''}
      {p.notif.msg}
    </div>
  );
}
